import { render, staticRenderFns } from "./media-planning-campaign-reports-app.vue?vue&type=template&id=5f2145dc"
import script from "./media-planning-campaign-reports-app.vue?vue&type=script&lang=js"
export * from "./media-planning-campaign-reports-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports